<template>
  <section class="schedulelist-container">
    <base-header
      v-bind="headers"
      v-on:handleCreate="handleHeaderCreate"
    />
   <base-table
      v-bind="list"
      v-on:handleSelectionChange="handleSelectionChange"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #title="scope">
        <div class="jee-color" @click="rowHref(scope.scope.row)"><div class="item-new jee-bg-light" v-if="scope.scope.row.readStatus === 0">NEW</div>{{scope.scope.row.title}}</div>
      </template>
    </base-table>
    <form-dialog
      :title="detailFormTitle"
      ref="lookDialog"
      :buttons="lookButtons"
    >
    <div class="dialog-box">
      <div class="dialog-header">
        <div class='title'>{{message.title}}</div>
        <p><span class="label">发送时间</span>：<span>{{message.showTime}}</span></p>
      </div>
      <div class="dialog-content">
        <p>
          {{message.content}}
        </p>
      </div>
    </div>
    </form-dialog>
  </section>
</template>

<script>
// import searchHeader from '@/components/mixins/searchHeader'
import baseTable from '@/components/mixins/baseTable'
import baseHeader from '@/components/mixins/baseHeader'
import formDialog from '@/components/mixins/formDialog'
export default {
  name: 'inMailIndex',
  mixins: [baseTable, baseHeader, formDialog],
  data () {
    return {
      list: {
        showIndex: false,
        showSelection: false,
        columns: [
          {
            prop: 'title',
            label: '标题',
            scopeType: 'slot',
            minWidth: '175px'
          },
          {
            scopeType: 'time',
            prop: 'showTime',
            label: '发送时间',
            minWidth: '175px'
          }
        ],
        api: 'fetchOabuinessNoticeMessList',
        params: {},
        handleColumnProp: {},
        handleColumn: []
      },
      headers: {
        buttons: [
          {
            type: 'Create',
            text: '清除未读',
            icon: '',
            notDisabled: true
          }
        ],
        showAlertIcon: false,
        content: ''
      },
      lookButtons: [],
      message: {},
      detailFormTitle: '查看通知'
    }
  },
  methods: {
    handleHeaderCreate () {
      this.$confirm('确定清除未读吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fetchOabuinessScheduleMessReadAll()
      })
    },
    rowHref (row) {
      let id = row.id
      this.message = row
      this.detailFormTitle = `查看通知（${row.noticeTime}）`
      this.$refs.lookDialog.showDialog()
      this.$request.fetchOabuinessScheduleMessRead({ id: id }).then(res => {})
      this.fetchTableApi()
    },
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content
        this.list.totalCount = res.data.totalElements
      }
    },
    // 标记已阅读
    fetchOabuinessScheduleMessReadAll () {
      this.list.loading = true
      this.$request.fetchOabuinessScheduleMessReadAll({}).then(res => {
        if (res.code === 200) {
          this.fetchTableApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    }
  },
  created () {

  }
}
</script>

<style lang="scss">
.schedulelist-container{
  .item-new {
    display: inline-block;
    border-radius:2px;
    font-size:14px;
    width: 38px;
    height: 20px;
    line-height: 20px;
    color:#ffffff;
    text-align: center;
    flex: 0 0 auto;
    margin-right: 6px;
  }
  .search-item-wrap:nth-child(3){
    width: 100px;
  }
  .jee-color{
    cursor: pointer;
  }
  .dialog-box{
    border:1px solid rgba(237,237,237,1);
    border-radius:0px 0px 4px 4px;
    .dialog-header{
      padding: 20px;
      border-bottom: 1px solid rgba(237,237,237,1);
      background:rgba(250,250,250,1);
      .title{
        color: #333333;
        font-size: 16px;
        font-weight: 600;
      }
      .label{
        color: #999999;
        width: 70px;
        font-size: 14px;
        display: inline-block;
        margin-top: 10px;
        text-align-last: justify;
      }
      span{
        color: #333333;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .dialog-content{
      overflow: scroll;
      max-height: 355px;
      p{
        text-indent:28px;
        font-size: 14px;
        color: #333333;
        padding: 20px;
      }
    }
  }
  .base-header-container{
    margin-top: 10px;
  }
}
</style>
